const eventDefinitionsMap = {
    'COMPLETE_MEDITATION_FULFILLED': {
        eventName: 'complete-meditation',
        eventFields: (state, action) => (action.payload),
    },

    'PLAY_MEDITATION': {
        eventName: 'play-meditation',
        eventFields: (state, action) => (action.payload),
    },

    'PAUSE_MEDITATION': {
        eventName: 'pause-meditation',
        eventFields: (state, action) => (action.payload),
    },

    'REGISTER_FULFILLED': {
        eventName: 'register',
        eventFields: (state, action) => (action.payload),
    },

    'PAGE_VIEW_FULFILLED': {
        eventName: 'custom-page-view',
        eventFields: (state, action) => (action.payload),
    }
};

export default eventDefinitionsMap;


// WEBPACK FOOTER //
// ./src/utils/eventDefinitionsMap.js